










import SearchPartner from '@/views/organisms/SearchPartner.vue'
import ApiClient from '@/common/api'
import store from '@/store'
import Global from '@/common/global.js'
import GreenButton from '@/views/atoms/GreenButton.vue'
import SelectBox from '@/views/atoms/SelectBox.vue'
import CheckBox from '@/views/atoms/CheckBox.vue'
import PopupCommentAdd from '@/views/template/PopupCommentAdd.vue'
import PopupSelectAdd from '@/views/template/PopupSelectAdd.vue'
import PopupDisplayItem from '@/views/template/PopupDisplayItem.vue'
import PopupFileUpload from '@/views/template/PopupFileUpload.vue'
import StatusBox from '@/views/molecules/StatusBox.vue'
import PartnerRow from '@/views/organisms/PartnerRow.vue'
import PopupVehicleInformationComment from '@/views/template/PopupVehicleInformationComment.vue'
import PopupWorkingStyle from '@/views/template/PopupWorkingStyle.vue'

export default
  name: 'Fc'

  components: {
    SearchPartner
    ApiClient
    GreenButton
    SelectBox
    CheckBox
    PopupCommentAdd
    PopupSelectAdd
    PopupDisplayItem
    PopupFileUpload
    StatusBox
    PopupVehicleInformationComment
    PopupWorkingStyle
    PartnerRow
  }

  data: () ->
    exportList: {},
    statusList: Global.status(),
    showDisplayItem: false,
    id: '',
    defaultNum: 0,
    displayItems: store.getters.defaultSetPartnerDisplayItems,
    searchParam: {}
    partnerLabel: Global.partnerLabel()

  created: () ->
    store.dispatch('initPostParam')
    api = new ApiClient()
    data = await api.get('/partner/list')
    @exportList = data.list
    if store.getters.defaultSetPartnerDisplayItems
      store.dispatch('setPartnerDisplayItems', store.getters.defaultSetPartnerDisplayItems)

  methods: {
    getList:() ->
      post = false
      api = new ApiClient()
      for index,row of @searchParam
        if typeof(row) == 'boolean' || (row && row != '')
          post = true
          break
      if post
        data = await api.post('/partner/list', @searchParam)
      else
        data = await api.get('/partner/list')
      @exportList = data.list

    click_search: (postParam) ->
      @searchParam = postParam
      api = new ApiClient()
      data = await api.post('/partner/list', postParam)
      @exportList = data.list

    clickDisplayItem: () ->
      @showDisplayItem = true
    closeDisplayItem: (e) ->
      @showDisplayItem = false
    click_clear: (postParam) ->
      @searchParam = postParam
  }
